var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "correo-electronico_1_",
    "data-name": "correo-electronico (1)",
    transform: "translate(-3 -85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7767",
    "data-name": "Grupo 7767",
    transform: "translate(3 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4381",
    "data-name": "Trazado 4381",
    d: "M17.077,85.333H.923A.926.926,0,0,0,0,86.256V96.41a.926.926,0,0,0,.923.923H17.077A.926.926,0,0,0,18,96.41V86.256A.926.926,0,0,0,17.077,85.333Zm-.346.692-7.2,5.4a.965.965,0,0,1-1.062,0l-7.2-5.4Zm-3.846,5.756,3.923,4.846.013.013H1.179l.013-.013,3.923-4.846a.346.346,0,0,0-.538-.436l-3.885,4.8V86.458l7.361,5.521a1.652,1.652,0,0,0,1.892,0l7.361-5.521v9.687l-3.885-4.8a.346.346,0,0,0-.538.436Z",
    transform: "translate(0 -85.333)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.886ca2649934d1e2d8b68a56a684ec81.svg";
export { ForwardRef as ReactComponent };